import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const ContactInner = () => {
    // Estado para armazenar os valores dos inputs do formulário
    const [formData, setFormData] = useState({
        nome: '',
        email: '',
        telefone: '',
        servico: 'Selecione o Serviço',
        mensagem: ''
    })

    // Função para atualizar o estado conforme o usuário digita/seleciona
    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    // Função para enviar os dados para o WhatsApp
    const handleSubmit = (e) => {
        e.preventDefault()

        const telefoneWhatsApp = '5511913292398' // Código do país + DDD + Número

        // Monta o texto que vai formatado para o WhatsApp
        const texto = `Olá! Gostaria de solicitar um Diagnóstico:%0A` +
            `*Nome:* ${formData.nome}%0A` +
            `*E-mail:* ${formData.email}%0A` +
            `*Telefone:* ${formData.telefone}%0A` +
            `*Serviço:* ${formData.servico}%0A` +
            `*Mensagem:* ${formData.mensagem}`

        // Abre o link do WhatsApp em uma nova aba
        window.open(`https://api.whatsapp.com/send?phone=${telefoneWhatsApp}&text=${texto}`, '_blank')
    }

    return (
        <>
            <div className="map-sec">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.170669274291!2d-46.65756852485542!3d-23.561491761614056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce59c7d8124231%3A0x673c0919323c9077!2sAv.%20Paulista%2C%201636%20-%20Bela%20Vista%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2001310-200!5e0!3m2!1spt-BR!2sbr!4v1717865000000!5m2!1spt-BR!2sbr"
                    allowFullScreen=""
                    loading="lazy"
                    title='Grupo Rocvel Localização'
                />
            </div>
            <div className="map-sec">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.332923448691!2d-46.662654200000006!3d-23.5564836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce582d17500c27%3A0x689792c2f6676864!2sAv.%20Paulista%2C%202439%20-%2011%20andar%20-%20Bela%20Vista%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2005419-000!5e0!3m2!1spt-BR!2sbr!4v1783967597879!5m2!1spt-BR!2sbr"
                    allowFullScreen=""
                    loading="lazy"
                    title='Grupo Rocvel Localização'
                />
            </div>

            <div className="contact-area space">
                <div className="container">
                    <div className="contact-page-wrap bg-theme">
                        <div className="row gy-40 align-items-center">
                            {/* Telefone */}
                            <div className="col-lg-4 col-md-6">
                                <div className="contact-info">
                                    <div className="contact-info_icon"><i className="fas fa-phone-alt" /></div>
                                    <div className="contact-info_details">
                                        <h6 className="contact-info_title">Central de Atendimento</h6>
                                        <p className="contact-info_text">
                                            <span>(11) 91525-9017</span> <br />
                                            <span>(11) 91329-2398</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* Localização */}
                            <div className="col-lg-4 col-md-6">
                                <div className="contact-info">
                                    <div className="contact-info_icon"><i className="fas fa-map-marker-alt" /></div>
                                    <div className="contact-info_details">
                                        <h6 className="contact-info_title">Nossas Unidades</h6>
                                        <p className="contact-info_text" style={{fontSize: '13px'}}>
                                            Unidade I: Av. Paulista, 1636 Conj. 05 <br />
                                            Unidade II: Av. Paulista, 2439 11º Andar
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* E-mail */}
                            <div className="col-lg-4 col-md-6">
                                <div className="contact-info">
                                    <div className="contact-info_icon"><i className="fas fa-envelope" /></div>
                                    <div className="contact-info_details">
                                        <h6 className="contact-info_title">E-mail Comercial</h6>
                                        <p className="contact-info_text">
                                            <span>atendimento@gruporocvel.com.br</span> <br />
                                            <span>comercial@gruporocvel.com.br</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="space-bottom">
                <div className="container">
                    <div className="row gy-40 justify-content-between">
                        <div className="col-lg-4">
                            <div className="title-area mb-0">
                                <span className="sub-title">
                                    <img src="assets/img/icon/title_left.svg" alt="shape" />
                                    Fale com um Especialista
                                </span>
                                <h2 className="sec-title style2">Agende seu Diagnóstico</h2>
                                <p className="mb-40">
                                    Nossa equipe está pronta para entender as dores do seu RH e desenhar a estratégia ideal para elevar a performance do seu negócio.
                                </p>
                                <div className="social-btn style4">
                                    <Link to="https://www.facebook.com/share/1DUYht6Ytb/?mibextid=wwXIfr"><i className="fab fa-facebook-f" /></Link>
                                    <Link to="https://www.instagram.com/grupo.rocvel/"><i className="fab fa-instagram" /></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-8">
                            <form onSubmit={handleSubmit} className="contact-form">
                                <div className="row">
                                    <div className="col-md-6 form-group">
                                        <input 
                                            type="text" 
                                            name="nome"
                                            placeholder="Seu Nome" 
                                            className="form-control style-border" 
                                            value={formData.nome}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6 form-group">
                                        <input 
                                            type="email" 
                                            name="email"
                                            placeholder="Seu E-mail" 
                                            className="form-control style-border" 
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6 form-group">
                                        <input 
                                            type="text" 
                                            name="telefone"
                                            placeholder="Seu Telefone" 
                                            className="form-control style-border" 
                                            value={formData.telefone}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6 form-group">
                                        <select 
                                            name="servico" 
                                            id="subject" 
                                            className="form-select style-border"
                                            value={formData.servico}
                                            onChange={handleChange}
                                        >
                                            <option value="Selecione o Serviço" disabled>Selecione o Serviço</option>
                                            <option value="Recrutamento e Seleção">Recrutamento e Seleção</option>
                                            <option value="Hunting Especializado">Hunting Especializado</option>
                                            <option value="Estruturação de Equipes">Estruturação de Equipes</option>
                                            <option value="RPO - Recrutamento Process Outsourcing">RPO - Recrutamento Process Outsourcing</option>
                                            <option value="Consultoria em RH">Consultoria em RH</option>
                                        </select>
                                        <i className="fas fa-angle-down" />
                                    </div>
                                    <div className="col-12 form-group">
                                        <textarea 
                                            name="mensagem"
                                            placeholder="Como podemos ajudar?" 
                                            className="form-control style-border" 
                                            value={formData.mensagem}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-12 form-group mb-0">
                                        <button type="submit" className="global-btn w-100">
                                            Enviar Diagnóstico <img src="assets/img/icon/right-icon.svg" alt="ícone" />
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactInner